import React, { useRef, useState } from 'react';
import { GetServerSideProps } from 'next';
import type { WBabyRegistrySearchHitView } from '@zola/svc-web-api-ts-client';
import { UserContext } from '@zola-helpers/client/dist/es/@types';
import { Page, Grid, ModuleTile } from '@zola/zola-ui/src/components/Grid';
import BabyFooter from '@zola/zola-ui/src/components/footers/baby/BabyFooter';

import BabySearchResultsSection from 'components/BabySearch/BabySearchResultsSection';
import { DeviceProvider } from 'contexts/DeviceContext';
import BabySearch from 'components/BabySearch/v3/components/BabySearch';

import FindACoupleMeta from 'components/BabySearch/Meta';

import { fetchNavHTML } from 'libs/server/nav';
import Nav from 'components/Nav';
import { fetchUser } from 'libs/server/users';
import IncomingMessageWithCookies from 'types/IncomingMessageWithCookies';

// need to update zola-ui to export properly
import COLORS from '@zola/zola-ui/src/styles/emotion/colorsBaby';
import BabyBackgroundModuleTile from 'components/ui/BabyBackgroundModuleTile';

interface BabySearchProps {
  navHTML: string | null;
  userCtx: UserContext | null;
  userAgent: string | undefined;
}

const BabySearchPage: React.FC<BabySearchProps> = (props): JSX.Element => {
  const { navHTML, userAgent } = props;
  const [result, setResult] = useState<Array<WBabyRegistrySearchHitView> | undefined>();
  const searchResultsRef = useRef<HTMLDivElement>(null);

  return (
    <DeviceProvider userAgent={userAgent}>
      <FindACoupleMeta />
      <Nav navHTML={navHTML} showPromo user={null} disablePrimaryNavCollapse disableSecondary />
      <Page>
        <Grid>
          <ModuleTile>
            <BabySearch handleSearchResult={setResult} searchResultsRef={searchResultsRef} />
            {result && (
              <BabySearchResultsSection
                babySearchResult={result}
                searchResultsRef={searchResultsRef}
              />
            )}
          </ModuleTile>
          <BabyBackgroundModuleTile background={COLORS.PD_ULTRAMARINE_100} />
          <BabyFooter />
        </Grid>
      </Page>
    </DeviceProvider>
  );
};

export const getServerSideProps: GetServerSideProps<BabySearchProps> = async ({
  req,
}: {
  req: IncomingMessageWithCookies;
}) => {
  const [navHTML, userCtx] = await Promise.all([fetchNavHTML(req), fetchUser(req)]);
  const userAgent = req.headers['user-agent'];

  return {
    props: {
      navHTML,
      userCtx,
      userAgent,
    },
  };
};

export default BabySearchPage;
